export default __webpack_public_path__ + "static/media/tech1.01754bb5.wav";